import {useEffect, useState, useContext} from "react";
import { DataContext } from "contexts/DataContext";
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import CheckCircle from "@mui/icons-material/CheckCircle";
import LinearProgress from '@mui/material/LinearProgress';
import { getCategories, searchControl } from "./api";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
interface AssessmentNavigatorProps {
    currentCategory: string;
    currentSubcategory: string;
    selectCategory: (category: string) => void;
    selectSubcategory: (subcategory: string) => void;
    categories?: any;
    searchOpen?: boolean;
}   
interface Option {
    id_control: string; 
    id_category: string; 
    id_subcategory: string; 
  }
  
const AssessmentNavigator = (props: AssessmentNavigatorProps) => {
    const dataContext = useContext(DataContext);
    const [categories, setCategories] = useState([] as any);
    const [currentCategory, setCurrentCategory] = useState('' as any);
    const [currentSubcategory, setCurrentSubcategory] = useState('' as any);

    const [options, setOptions] = useState<Option[]>([]);
    const [inputValue, setInputValue] = useState(''); 
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
      const loadOptions = async () => {
        if (inputValue.trim().length < 2) return;  // Avvia la ricerca solo se ci sono abbastanza caratteri
  
        setLoading(true);
        try {
          searchControl(dataContext.currentAssessment, inputValue).then((response) => {
            setOptions(response); // Supponiamo che l'API restituisca un array di opzioni
            setLoading(false);  
          });
        } catch (error) {
          console.error('Errore nel caricamento dei dati:', error);
        }
      };
  
      loadOptions();
      //eslint-disable-next-line
    }, [inputValue]);

    useEffect(() => {
        if(dataContext.loading) return;
        if(!dataContext.currentAssessment) return;
        setCurrentCategory(props.currentCategory);
        setCurrentSubcategory(props.currentSubcategory);
        if(props.categories) {
            setCategories(props.categories);
        } else {
            getCategories(dataContext.currentAssessment).then((response) => {
                setCategories(response);
            });
        }
        //eslint-disable-next-line
    }, [dataContext.loading, dataContext.currentAssessment]);

    return (
	    <>
	        <Box>
        {props.searchOpen && 
        <Autocomplete
            sx={{marginBottom:'10px', marginTop:'10px'}}
            options={options}
            loading={loading}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            getOptionLabel={(option) => option.id_control || ''}
            onChange={(event, option) => {
                navigate(`/assessment/questionnaire/${option?.id_category}/${option?.id_subcategory}/${option?.id_control}`);
            }}
            renderInput={(params) => (
                <TextField
                {...params}
                label="Cerca..."
                variant="outlined"
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                    <>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                    </>
                    ),
                }}
                />
            )}
            />
        }
	        {categories.categories?.map((category: any, index: number) => { 
	            return (
	                <Box key={index} sx={{display:'flex', flexDirection:'row'}}>
	                        <Box height={'25px'} marginRight={'10px'} display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
	                            <Box width={70} marginBottom={'2px'}>
	                                <LinearProgress  variant="determinate" value={(category.completed/category.total)*100} color="info" />
	                            </Box>
	                            <Box width={70}>
	                                <LinearProgress  variant="determinate" value={(category.approved/category.total)*100} color="warning" />
	                            </Box>
	                        </Box>
	                        <Chip 
	                        variant="outlined" 
	                        label={category.id_category} 
	                        size="small"
	                        sx={{
	                            minWidth:80, 
	                            fontSize:12, 
	                            color:'white',
	                            fontWeight:600,
	                            padding:0,
	                            margin:'1px 0px',
	                            height:23,
	                            borderColor: (theme) =>
	                              theme.palette.mode === 'light'
	                                ? 'transparent'
	                                : categories.functions?.colors[category.id_function],
	                            backgroundColor: (theme) =>
	                              theme.palette.mode === 'light'
	                                ? (categories.functions?.colors[category.id_function]=='#CCCC43' ? '#f5b400' :
	                                   categories.functions?.colors[category.id_function]=='#3F5A98' ? '#10aeed' :
	                                   categories.functions?.colors[category.id_function]=='#532A7B' ? '#a759f9' :
	                                   categories.functions?.colors[category.id_function]=='#3F8A49' ? '#90d31d' :
	                                   categories.functions?.colors[category.id_function]=='#BB291C' ? '#ef1404' :                                   categories.functions?.colors[category.id_function]=='#6E6E6E' ? '#bdbdbd' :	                                   '#000000')
	                                : 'transparent'
	                        }} />

	                        <Box sx={{marginLeft:1, cursor:'pointer',lineHeight:'23px'}}>
                        <Box onClick={()=>props.selectCategory(category.id_category)}>
                        <Typography 
                            variant={currentCategory===category.id_category ? 'categoryActive' : 'category'} 
                            sx={{marginLeft:0}}
                            >
                            {categories.completed.categories && categories.completed.categories[category.id_category] ? <CheckCircle sx={{height:'10px', width:'10px', marginRight:'2px'}}/> : ''}
                            {category.category_name}
                        </Typography>
                        </Box>
                        {[2,3].includes(dataContext.user.id_role) &&
                        currentCategory===category.id_category && <Box>
                        {categories.subcategories[category.id_category] && categories.subcategories[category.id_category].map((subcategory: any, index: number) => {
                            return (
                            <span key={index}>
                            <Typography variant="category" sx={{color:'#666'}}> | </Typography>
                            <Box onClick={()=>props.selectSubcategory(subcategory.id_subcategory)} sx={{display:'inline', cursor:'pointer',lineHeight:'20px'}}>
                            <Typography key={index} variant={currentSubcategory===subcategory.id_subcategory ? 'categoryActive' : 'category'}>
                               {categories.completed.subcategories && categories.completed.subcategories[subcategory.id_subcategory] ? <CheckCircle sx={{height:'10px', width:'10px', marginRight:'2px'}}/> : ''}
                               {subcategory.id_subcategory} {' '}
                            </Typography>
                            </Box>
                            </span>
                            )
                            })}
                            <Typography variant="category" sx={{color:'#666'}}> | </Typography>
                            </Box>
                        }
                        </Box>
                       
                </Box>
            );
        })}
        </Box>
        </>
    );
}

export default AssessmentNavigator;